module.exports = __webpack_public_path__ + "img/e2.e8487879.png";